import type { ApiResponse } from "../../../types/apiResponse";
import type { AuthError, LoginFormData } from "../types/auth";
import { apiClient } from "../../../lib/apiClient";

const loginAPI = async (data: LoginFormData): Promise<ApiResponse> => {
  try {
    return await apiClient(`/v1/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    });
  } catch (error) {
    throw error as AuthError;
  }
};

export default loginAPI;
